import { render } from "./NovaKids.vue?vue&type=template&id=26196962"
import script from "./NovaKids.vue?vue&type=script&lang=js"
export * from "./NovaKids.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__